import { Observable, catchError } from "rxjs";
import { CheckoutInfoModel } from "../models/cart/checkout-info-model";
import { CheckoutResultInfoModel } from '../models/cart/checkout-result-info-model';
import { BaseApiService } from "./base-api.service";
import { ToasterNotificationService } from "./toaster-notification.service";
import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CheckoutFinalizeModel } from "../models/cart/checkout-finalize.model";

const AI_API_URL = `${environment.aiApiUrl}`;

@Injectable({
    providedIn: 'root'
})

export class CheckoutApiService extends BaseApiService {

    constructor(
        private http: HttpClient,
        override toasterNotificationService: ToasterNotificationService
    ) {
        super(toasterNotificationService);
    }

    cartCheckout(checkoutInfo: CheckoutInfoModel): Observable<CheckoutResultInfoModel | undefined> {
        const url = `${AI_API_URL}/Cart/cart-checkout`;
        return this.http.post<CheckoutResultInfoModel>(url, JSON.stringify(checkoutInfo))
            .pipe(
                catchError(err => this.handleError(err))
            );
    }

    createCheckoutSession(products: { productId: string, productType: any,  signUrl: string; }[]): Observable<any | undefined> {
        const url = `${AI_API_URL}/Cart/create-checkout-session`;
        var returnUrl = window.location.protocol + "//" + window.location.host + ''

        return this.http.post<CheckoutResultInfoModel>(url, JSON.stringify({ returnUrl, products }))
            .pipe(
                catchError(err => this.handleError(err))
            );
    }

    finalizeCheckoutSession(resultInfoId: string, responseJson: string): Observable<any | undefined> {
        const url = `${AI_API_URL}/Cart/finalize-checkout-session`;

        var checkoutFinalizeModel: CheckoutFinalizeModel = {
            checkoutResultInfoId: resultInfoId,
            tags: [responseJson]
        }

        return this.http.post<CheckoutFinalizeModel>(url, checkoutFinalizeModel)
            .pipe(
                catchError(err => this.handleError(err))
            );
    }

}